import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { FilterOptionLayout, PrintOptionFilterOptionDto } from '@/api-sdk';
import { BREAKPOINT_SMALL_PX } from '@/settings';
import { baseStyles } from '@/styles';

import './fg-print-option-filter-color-option';
import './fg-print-option-filter-logo-option';
import './fg-print-option-filter-option';

@customElement('fg-print-option-filter-options-list')
export class FgPrintOptionFilterOptionsList extends LitElement {
  @property({ type: Array })
  filterOptions: Array<PrintOptionFilterOptionDto> = [];

  @property({ type: String })
  filterOptionsLayout? = FilterOptionLayout.DEFAULT;

  renderFilterOption(filterOption: PrintOptionFilterOptionDto) {
    switch (this.filterOptionsLayout) {
      case 'colors':
        return html`
          <fg-print-option-filter-color-option
            .option=${filterOption}
          ></fg-print-option-filter-color-option>
        `;
      case 'personalization':
        return html`
          <fg-print-option-filter-logo-option
            .selectedPrintOption=${filterOption}
          ></fg-print-option-filter-logo-option>
        `;
      default:
        return html`
          <fg-print-option-filter-option
            .option=${filterOption}
          ></fg-print-option-filter-option>
        `;
    }
  }

  render() {
    return html`
      <div class=${`options-list ${this.filterOptionsLayout}`}>
        ${this.filterOptions.map(filterOption =>
          this.renderFilterOption(filterOption),
        )}
      </div>
    `;
  }

  static styles = [
    baseStyles,
    css`
      .options-list {
        display: grid;
        gap: 5px;
      }

      @media screen and (min-width: ${BREAKPOINT_SMALL_PX}px) {
        .options-list {
          gap: 10px;
          grid-template-columns: repeat(2, 1fr);
        }

        .options-list.colors {
          grid-template-columns: repeat(4, 1fr);
        }
      }
    `,
  ];
}
